import{jsx as e}from"react/jsx-runtime";import*as t from"react";class r extends t.Component{render(){return e("div",Object.assign({"data-testid":this.props.dataTestId},{children:this.props.children}))}}r.displayName="SelectValue";export{r as SelectValue};
//# sourceMappingURL=SelectValue.js.map
